import _ from 'lodash';

/* @ngInject */
export default function TotalFlowMeterService($sails, $q, $log, $uibModal) {
  const service = this;

  const hoursInDay = 24;
  const minsInHour = 60;
  const daysInWeek = 7;
  const thou = 1000;
  const A_DAY_IN_MILLIS = hoursInDay * minsInHour * minsInHour * thou;

  service.getEventsForPeriod = getEventsForPeriod;
  service.openTotalFlowModal = openTotalFlowModal;
  service.getConstants = getConstants;
  service.getGasConstants = getGasConstants;
  service.setConstants = setConstants;
  service.setGasConstants = setGasConstants;

  function getEventsForPeriod(equipmentIds, panel) {
    const now = Date.now();

    // gets totalFlow data
    const totalFlowDataCalls = _.reduce(equipmentIds, (calls, equipmentId) => {
      const days = parseInt(_.get(panel, ['config', equipmentId, 'daysOfDataToPull'], daysInWeek), 10);
      const then = now - (days * A_DAY_IN_MILLIS);
      calls.push($sails.get(`/event/totalFlowDataInPeriod/${equipmentId
      }?maxQueryDateRange=${days
      }&startDate=${then
      }&endDate=${now
      }${_.has(panel, ['config', equipmentId, 'listenForEvent']) ?
        `&eventName=${panel.config[equipmentId].listenForEvent}` : ''}`));
      return calls;
    }, []);

    return $q.all(totalFlowDataCalls)
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function openTotalFlowModal(totalFlow) {
    $uibModal.open({
      component: 'totalFlowSettingsModal',
      size: 'md',
      resolve: {
        totalFlow: () => totalFlow
      }
    });
  }

  function getConstants(equipmentId) {
    return $sails.get(`/equipment/${equipmentId}/statuses/getConstants/`)
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function getGasConstants(equipmentId) {
    return $sails.get(`/equipment/${equipmentId}/statuses/getGasConstants/`)
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function setConstants(equipmentId, updateObject) {
    return $sails.post(`/equipment/${equipmentId}/actions/setConstants/`, {
      id: equipmentId,
      constants: updateObject
    })
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function setGasConstants(equipmentId, updateObject) {
    return $sails.post(`/equipment/${equipmentId}/actions/setGasConstants/`, {
      id: equipmentId,
      gasConstants: updateObject
    })
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error.data);
      });
  }
}
